import { useState, useEffect } from "react";
import axios from "axios";
import { countContainers } from "../../../services/container";
import { addressCountSiteUsed } from "../../../services/address";

const SORTING_ERROR_OPTION_STORAGE_KEY =
  "statisticsActivatedSortingErrorOption";
/**
 * Hook pour charger les données de base des statistiques (nombre de conteneurs, sites)
 */
export const useStatisticsData = (
  keywordFilter,
  periodHistoryStart,
  periodHistoryStop,
) => {
  const [numberOfContainers, setNumberOfContainers] = useState(0);
  const [numberOfSite, setNumberOfSite] = useState(0);
  const [activatedSortingErrorOption, setActivatedSortingErrorOption] =
    useState(() => {
      try {
        return JSON.parse(
          localStorage.getItem(SORTING_ERROR_OPTION_STORAGE_KEY) || "false",
        );
      } catch {
        return false;
      }
    });

  useEffect(() => {
    const keywordValue =
      keywordFilter &&
      typeof keywordFilter === "object" &&
      "value" in keywordFilter
        ? keywordFilter.value
        : keywordFilter || [];

    axios
      .all([
        countContainers({ keywordFilter: JSON.stringify(keywordValue) }),
        addressCountSiteUsed({
          periodStart: periodHistoryStart,
          periodStop: periodHistoryStop,
          keywordFilter: JSON.stringify(keywordValue),
        }),
      ])
      .then(
        axios.spread((responseContainerCount, responseCountSite) => {
          if (
            responseContainerCount.status === 200 &&
            responseCountSite.status === 200
          ) {
            setActivatedSortingErrorOption(
              responseContainerCount.data.activatedSortingErrorOption,
            );
            localStorage.setItem(
              SORTING_ERROR_OPTION_STORAGE_KEY,
              JSON.stringify(
                responseContainerCount.data.activatedSortingErrorOption,
              ),
            );
            setNumberOfContainers(responseContainerCount.data.count);
            setNumberOfSite(responseCountSite.data.countSite);
          }
        }),
      );
  }, [keywordFilter, periodHistoryStart, periodHistoryStop]);

  return {
    numberOfContainers,
    numberOfSite,
    activatedSortingErrorOption,
  };
};
